import { NinjaTableContext } from 'components/tables/NinjaTable/NinjaTable';
import { useContext } from 'react';

/**
 *
 * @returns {{
 * }}
 */
export const useNinjaTable = () => useContext(NinjaTableContext);
